/**
 * Trim the string
 * @param {string} payload
 * @param {number} maxLength
 * @return {string}
 */
export default function trimString(payload: string, maxLength: number) {
  return payload.length >= maxLength ? (
    payload.substr(0, maxLength - 3) + '...'
  ) : payload;
}
